/**
 * @license
 * Copyright 厦门乾元盛世科技有限公司 All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file.
 */



import { Component, Input, Output, EventEmitter, ElementRef, Renderer, ViewEncapsulation } from '@angular/core';
import { OnInit, Inject, Optional, Host, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, COMPOSITION_BUFFER_MODE } from '@angular/forms';

import { FormControl } from '../input/form.control';
import { CheckboxGroup } from './checkbox.group';

const /** @type {?} */ INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => Checkbox),
    multi: true
};
export class Checkbox extends FormControl implements OnInit {
/**
 * 样式前缀
 */
prefixCls = 'ant-checkbox';
/**
 * 指定当前是否选中
 */
checked = false;
/**
 * 设置 indeterminate 状态，只负责样式控制
 */
indeterminate = false;
/**
 * 是否只读状态，默认为 false
 */
readOnly = false;
/**
 * 用户CSS样式
 */
class: string;
/**
 * 内部输入控件的tabIndex属性，默认情况下无需关注
 */
tabIndex: string;
/**
 * 值变更事件
 */
change = new EventEmitter<any>();
/**
 * Check变更事件
 */
check = new EventEmitter<boolean>();
/**
 * 内部默认的控件
 */
public type = 'checkbox';
/**
 * @param {?} renderer
 * @param {?} elementRef
 * @param {?} compositionMode
 * @param {?} group
 */
constructor(
private renderer: Renderer,
private elementRef: ElementRef,
private compositionMode: boolean,
private group: CheckboxGroup) {

        super(renderer, elementRef, compositionMode);
        this.value = 'on';
    }
/**
 * @return {?}
 */
getWrapperClass(): any {
        return {
            [`${this.getPrefixCls()}-wrapper`]: 1,
            [`${this.class}`]: this.class
        };
    }
/**
 * @return {?}
 */
getBoxClass(): any {
        return {
            [`${this.getPrefixCls()}`]: 1,
            [`${this.getPrefixCls()}-checked`]: this.checked,
            [`${this.getPrefixCls()}-disabled`]: this.disabled,
            [`${this.getPrefixCls()}-indeterminate`]: this.indeterminate
        };
    }
/**
 * @return {?}
 */
getPrefixCls(): string {
        return this.prefixCls;
    }
/**
 * @return {?}
 */
isGroupDisabled(): boolean {
        return this.group && this.group.disabled;
    }
/**
 * @return {?}
 */
ngOnInit(): void {
        // 处理CheckboxGroup的初始值
        if (this.group && this.value) {
            this.checked = this.group.hasValue(this.value);
        }
        this.disabled = this.disabled || this.isGroupDisabled() || false;
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any): void {
        if (value !== null) {
            this.checked = this.value === value;
        }
    }
/**
 * @param {?} event
 * @return {?}
 */
handleChange(event: Event): void {
        event.preventDefault();
        event.stopPropagation();
        if (this.disabled) {
            return;
        }
        this.checked = !this.checked;

        const /** @type {?} */ value = this.checked ? this.value : '';
        this.onChange(value);
        this.check.emit(this.checked);
        this.change.emit(value);
        this.makeGroupChange();
    }
/**
 * 如果Checkbox在CheckboxGroup内部，则触发CheckboxGroup的值变化
 * @return {?}
 */
makeGroupChange() {
        if (this.group) {
            this.group.toggle(this.value, this.checked);
        }
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ant-checkbox',
    templateUrl: './checkbox.html',
    styleUrls: ['./style/index.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [INPUT_CONTROL_VALUE_ACCESSOR],
    exportAs: 'checkbox'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Renderer, },
{type: ElementRef, },
{type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [COMPOSITION_BUFFER_MODE, ] }, ]},
{type: CheckboxGroup, decorators: [{ type: Inject, args: [forwardRef(() => CheckboxGroup), ] }, { type: Optional }, { type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'prefixCls': [{ type: Input },],
'checked': [{ type: Input },],
'indeterminate': [{ type: Input },],
'readOnly': [{ type: Input },],
'class': [{ type: Input },],
'tabIndex': [{ type: Input },],
'change': [{ type: Output },],
'check': [{ type: Output },],
};
}

function Checkbox_tsickle_Closure_declarations() {
/** @type {?} */
Checkbox.decorators;
/**
 * @nocollapse
 * @type {?}
 */
Checkbox.ctorParameters;
/** @type {?} */
Checkbox.propDecorators;
/**
 * 样式前缀
 * @type {?}
 */
Checkbox.prototype.prefixCls;
/**
 * 指定当前是否选中
 * @type {?}
 */
Checkbox.prototype.checked;
/**
 * 设置 indeterminate 状态，只负责样式控制
 * @type {?}
 */
Checkbox.prototype.indeterminate;
/**
 * 是否只读状态，默认为 false
 * @type {?}
 */
Checkbox.prototype.readOnly;
/**
 * 用户CSS样式
 * @type {?}
 */
Checkbox.prototype.class;
/**
 * 内部输入控件的tabIndex属性，默认情况下无需关注
 * @type {?}
 */
Checkbox.prototype.tabIndex;
/**
 * 值变更事件
 * @type {?}
 */
Checkbox.prototype.change;
/**
 * Check变更事件
 * @type {?}
 */
Checkbox.prototype.check;
/**
 * 内部默认的控件
 * @type {?}
 */
Checkbox.prototype.type;
/** @type {?} */
Checkbox.prototype.renderer;
/** @type {?} */
Checkbox.prototype.elementRef;
/** @type {?} */
Checkbox.prototype.compositionMode;
/** @type {?} */
Checkbox.prototype.group;
}




interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
